import React, { useEffect, useState } from "react";
import styled from "styled-components";

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import moment from "moment";

import UserProfile from "../../../../../Component/Normal/UserProfile";

import DefaultProfile from '../../../../../image/DefaultProfile.png';
import PointInput from "../../../../../Component/MemberComponent/MemberDetail/PointInput";
import CalenderInput from "../../../../../Component/MemberComponent/CalenderInput";
import PointReasonInput from "../../../../../Component/MemberComponent/MemberDetail/PointReasonInput";
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';

export default function PointSaveModal(props) {
  const { memberData, clickedPointHistory, onClickSave, onClickExit } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [memberId, setMemberId] = useState(0);
  const [memberName, setMemberName] = useState('');
  const [memberProfile, setMemberProfile] = useState('');

  const [pointHistoryId, setPointHistoryId] = useState(0);
  const [pointSign, setPointSign] = useState('Plus');
  const [point, setPoint] = useState(0);
  const [approvalDate, setApprovalDate] = useState(moment().format('YYYY.MM.DD'));
  const [reason, setReason] = useState('');

  // 회원 데이터 정리 //
  useEffect(() => {
    if (memberData !== undefined) {
      setMemberId(memberData.memberId);
      setMemberName(memberData.name);
      setMemberProfile(memberData.profile);
    }
  }, [memberData])

  // 수정할 데이터 클릭시 //
  useEffect(() => {
    if (clickedPointHistory === undefined) return;  
    
    setPointHistoryId(clickedPointHistory.pointHistoryId);
    setPointSign(clickedPointHistory.point >= 0 ? 'Plus' : 'Minus');
    setPoint(clickedPointHistory.point >= 0 ? (clickedPointHistory.point) : (clickedPointHistory.point * -1));
    setApprovalDate(moment(clickedPointHistory.approvalDate).format('YYYY.MM.DD'));
    setReason(clickedPointHistory.reason);
  }, [clickedPointHistory])

  // 포인트 추가 및 차감 텍스트 정리 //
  function decidePointDeltaText() {
    let finalPoint = point || 0;

    if (pointSign === 'Plus') return t('memberDetail.pointSaveModal.pointAdd').replace('{point}', parseInt(finalPoint).toLocaleString('ko-KR'));
    else return t('memberDetail.pointSaveModal.pointSubtract').replace('{point}', parseInt(finalPoint).toLocaleString('ko-KR'));
  }

  // 포인트 내역 추가 수정 저장 버튼 클릭시 //
  function onClickSaveButton() {
    let finalPoint = point || 0;
    let finalApprovalDate = moment(approvalDate).format('YYYY-MM-DDTHH:mm:ss');

    if (pointSign === 'Minus') finalPoint *= -1;

    onClickSave(memberId, pointHistoryId, finalPoint, finalApprovalDate, reason);
  }

  return (
    <TotalModalWrapper>
      <ModalView $isDark={isDark}>
        <TopComponentWrapper>
          <TitleWrapper>
            <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('memberDetail.pointSaveModal.title')}</Text>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.pointSaveModal.desc')}</Text>
          </TitleWrapper>
          <ButtonWrapper>
            <ExitButton onClick={onClickExit}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('memberDetail.pointSaveModal.btnCancel')}</Text>
            </ExitButton>
            <SaveButton onClick={onClickSaveButton}>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('memberDetail.pointSaveModal.btnSave')}</Text>
            </SaveButton>
          </ButtonWrapper>
        </TopComponentWrapper>
        <MemberInfoBoxWrapper>
          <MemberInfoBox>
            <ProfileBox>
              <UserProfile profile={memberProfile} defaultProfile={DefaultProfile} />
            </ProfileBox>
            <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{memberName}</Text>
            {/* <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>크로스핏 3개월 회원권</Text> */}
          </MemberInfoBox>
          <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={pointSign === 'Plus' ? theme.subKey : theme.pointRed} cursor='default'>{decidePointDeltaText()}</Text>
        </MemberInfoBoxWrapper>
        <DivisionLine />
        <PointInfoWrapper>
          <ComponentWrapper>
            <PointAddButton isClicked={pointSign === 'Plus'} onClick={() => setPointSign('Plus')}>
              <PlusBox>
                <Stick width={14} height={2} />
                <Stick width={2} height={14} />
              </PlusBox>
            </PointAddButton>
            <PointSubtractButton isClicked={pointSign === 'Minus'} onClick={() => setPointSign('Minus')}>
              <PlusBox>
                <Stick width={14} height={2} />
              </PlusBox>
            </PointSubtractButton>
          </ComponentWrapper>
          <PointInput value={point} setValue={setPoint}/>
          <ComponentWrapper>
          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.pointSaveModal.pointApplyDate')}</Text>
          <CalenderInput
            value={approvalDate}
            setValue={setApprovalDate}
            selectClickFn={() => {}}
            className='ApprovalCalender'
            clickFn={() => {}}
            placeholder={t('memberDetail.pointSaveModal.placeholderApplyDate')}
            width={171}
            disabled={false} />
          </ComponentWrapper>
        </PointInfoWrapper>
        <ReasonBoxWrapper>
          <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.pointSaveModal.reason')}</Text>
          <PointReasonInput value={reason} setValue={setReason}/>
        </ReasonBoxWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px;

  width: 700px;

  border-radius: 10px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const TopComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;
  
  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const MemberInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 10px;

  width: 100%;
`;

const MemberInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ProfileBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border-radius: 2px;

  overflow: hidden;
`;

const DivisionLine = styled.div`
  margin: 16px 0px;

  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};

  transition: all 0.3s ease-in-out;
`;

const PointInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const PointAddButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 30px;

  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.subKey : props.theme.line};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PointSubtractButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 30px;

  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.pointRed : props.theme.line};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PlusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 14px;
`;

const Stick = styled.div`
  position: absolute;
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 2px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const ReasonBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 16px;

  width: 100%;

  gap: 8px;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  transition: all 0.3s ease-in-out;
`;